exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden\n}", ""]);

// exports
